import { Injectable } from '@angular/core';
import { HEADQUARTER_ROLES, OFFER_ROLES, RoleType } from '@elio/emanager-front/shared/models';
import { SelectOption } from '@elio/shared/models';

@Injectable()
export class UserRoleOptionsBuilder {
  getRoles(type: 'offer' | 'headquarter', withSupervision: boolean): SelectOption[] {
    const rolesList = (type === 'offer' ? OFFER_ROLES : HEADQUARTER_ROLES).filter(
      (r) => withSupervision || (r !== 'SUPERVISION' && r !== 'SUPERVISION_HEADQUARTER')
    );
    return rolesList.map((role: RoleType) => {
      const roleStr = role.toString();
      return {
        value: roleStr,
        display: 'role.' + roleStr,
      };
    });
  }
}
